import styled from 'styled-components';

export const ReuseIOConfigurationStyled = styled.div`
  .createCampaignReuseIOConfiguration {
    &__bulkCreation {
      display: flex;
      flex-direction: column;
      margin-top: 32px;

      &Enable {
        align-items: center;
        display: inline-flex;
        flex-direction: row;
        margin-bottom: 8px;
        gap: var(--spacing-8);
      }

      &SelectorsItem {
        margin-top: var(--spacing-8);

        .selectorLabelContainer {
          margin-right: 8px;
        }

        .singleSelectorComponent {
          width: 180px;
        }
      }

      &Subtitle {
        color: var(--color-sonata-primary-700, #283D60);
        font: var(--font-info-600-regular);
      }

      &Asterisk {
        color: ${props => props.theme.uiColors.multiflightLineItemBulkAsteriskColor};
        font-size: 12px;
        margin-top: 96px;
      }
    }

    &__options {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }
`;
